(() => {
  if (window.JJShoppingDetails) return;
  window.JJShoppingDetails = true;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = () => {
    document.querySelectorAll('.jj-policy-dialog').forEach((dialog) => {
      if (dialog.dataset.bound) return;
      dialog.dataset.bound = 'true';
      dialog.querySelector('[data-policy-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => document.dispatchEvent(new Event('jj:overlay-change')));
    });
    document.querySelectorAll('main a[href], #MainContent a[href], .footer-group a[href]').forEach((link) => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const policy = document.querySelector(`.jj-policy-dialog[data-policy-path="${CSS.escape(url.pathname)}"]`);
      if (!policy) return;
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', policy.id);
      link.dataset.jjPolicy = policy.id;
    });
  };
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const dialog = link.dataset.jjPolicy && document.getElementById(link.dataset.jjPolicy);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
      document.dispatchEvent(new Event('jj:overlay-change'));
      return;
    }
    if (!document.querySelector('.jj-starter-polished') || !link.closest('#MainContent, [data-ev-dock]')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash || url.hash === '#') return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('.header');
    const offset = (header?.getBoundingClientRect().height || 64) + 20;
    const top = Math.max(0, scrollY + target.getBoundingClientRect().top - offset);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    window.scrollTo({ top, behavior: reducedMotion() ? 'instant' : 'smooth' });
    if (location.hash !== url.hash) history.pushState(history.state, '', url.hash);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
